import { Link } from "react-router-dom";
import styles from "./LandingPage.module.css";

// V2 버튼이 연결할 주소
const V2_URL = "https://gang-z.site/v2";

export default function LandingPage() {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {/* Logo */}
        <div className={styles.logo}>
          <span className={styles.logoStar}>✦</span>
          <div>
            <div className={styles.logoTitle}>Gang-Z</div>
            <div className={styles.logoSub}>ADMIN CONSOLE</div>
          </div>
        </div>
        <div className={styles.subtitle}>버전을 선택하세요</div>

        <div className={styles.options}>
          <Link to="/v1" className={styles.option}>
            <div className={styles.badge}>V1</div>
            <div className={styles.optionText}>
              <div className={styles.optionTitle}>관리자 콘솔 V1</div>
              <div className={styles.optionDesc}>현재 운영 중인 대시보드</div>
            </div>
            <span className={styles.arrow}>→</span>
          </Link>

          <a href={V2_URL} className={styles.option}>
            <div className={styles.badge}>V2</div>
            <div className={styles.optionText}>
              <div className={styles.optionTitle}>데이터 관리 대시보드</div>
              <div className={styles.optionDesc}>카드 뉴스 생성</div>
            </div>
            <span className={styles.arrow}>→</span>
          </a>
        </div>
      </div>
    </div>
  );
}
